<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    no-data-text="Раздел не найден"
    :request="request"
    label="Выберите публикацию из списка"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { LkEventPublicationsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'
import BAutocomplete from '../BAutocomplete.vue'

export default {
  name: 'BAutocompleteEventPublications',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new LkEventPublicationsApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(...args) {
      return this.adapter.api.getPublications(...args)
    },
  },
}
</script>
